import React, { useEffect, useState } from "react";
import SegmentGroupForm from "./SegmentGroupForm";
import constants from "../../../Utils/constants";
import { MasterServices } from "../../../Services/Master";
import { useHistory } from "react-router-dom";
import Toast from "../../../Utils/Toast";
import { SegmentGroupServices } from "./SegmentGroupsServices";
import { formatRoute } from "react-router-named-routes";

function EditSegmentGroup({ match }) {
  const history = useHistory();
  const id = match.params.id;
  const [initialData, setInitialData] = useState(null);

  const fetchGroupData = async () => {
    await SegmentGroupServices.getSegmentSubGroupsWithId(id)
      .then(res => {
        const subGroupData = res.data.data;
        setInitialData({
          subGroupName: subGroupData.name,
          priority: subGroupData.priority,
          lobCheckedIds: JSON.parse(subGroupData.lob_ids),
          group_id: subGroupData.group_id,
        });
      })
      .catch(e => {
        console.error(e);
      });
  };
  useEffect(() => {
    fetchGroupData();
  }, [id]);

  const fetchCategoryData = async () => {
    return new Promise((resolve, reject) => {
      MasterServices.getCategories(`metric_category?metric_category_type_id=1&active=1`)
        .then(res => {
          resolve(res.data.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  };

  const handleEditGroupTemplate = async ({ subGroupName, lobCheckedIds, segmentGroup, priority }) => {
    try {
      await SegmentGroupServices.editSegmentSubGroup(
        {
          name: subGroupName,
          lob_ids: JSON.stringify(lobCheckedIds),
          group_id: segmentGroup.id,
          priority: priority,
        },
        id,
      );
      Toast(constants.SEGMENT_SUB_GROUP.EDIT.SUCCESS, "success");
      history.push({
        pathname: formatRoute(constants.APPLICATION_ROUTE.SEGMENT_GROUP_AND_SUB_GROUP.ROUTE, {}),
        search: "?selected_tab=" + constants.APPLICATION_ROUTE.SEGMENT_GROUP_AND_SUB_GROUP.TABS[1].KEY,
      });
    } catch (e) {
      Toast(e.data.error, "error");
    }
  };

  const breadcrumbsConfig = [
    {
      title: constants.APPLICATION_ROUTE.SEGMENT_SUB_GROUP.LIST.HEADER_TITLE,
      link: constants.APPLICATION_ROUTE.SEGMENT_SUB_GROUP.LIST.ROUTE,
      is_active: false,
    },
    {
      title: initialData?.subGroupName,
      link: null,
      is_active: true,
    },
  ];

  return initialData ? (
    <SegmentGroupForm
      breadcrumbsConfig={breadcrumbsConfig}
      fetchCategoryData={fetchCategoryData}
      handleSubmit={handleEditGroupTemplate}
      initialData={initialData}
      group_id={initialData.group_id}
    />
  ) : null;
}

export default EditSegmentGroup;
